(function() {
    'use strict';

    angular.module('app').directive('aggregateQuantity', aggregateQuantity);

    function aggregateQuantity() {
        return {restrict: 'A', link: link, scope: {bind: '=aggregateBind'}};

        function link($scope, $element) {
            var initial;
            $element.ready(apply);

            function apply() {
                $element.on('focus', initVariables);
                $element.on('blur change input', onChange);

                function initVariables(){
                    initial = parseInt($element.val());
                    $scope.previousQty = parseInt(isNaN(initial) ? 0 : initial);
                }

                function onChange() {
                    var current = parseInt($(this).val());
                    // If the current value is not an int, then make it an int - 0.
                    if (isNaN(current)) {
                        current = 0;
                    }

                    // If the bound qty is reset, then reset this input also
                    if ($scope.bind === 0) {
                        $scope.previousQty = 0;
                    }

                    $scope.bind = parseInt($scope.bind) + current - $scope.previousQty;
                    $scope.previousQty = current;
                    $scope.$apply();
                }
            }
        }
    }
})();
